import { useState } from "react";
import YesNo from "./YesNo";

## Basic Usage

export function BasicYesNo() {
  const [value, setValue] = useState(undefined);
  return (
    <div>
      <YesNo onUpdate={setValue} />
      <p style={{ marginTop: "0.5rem" }}>
        Value: **{value === undefined ? "undefined" : value ? "true" : "false"}**
      </p>
    </div>
  );
}

<BasicYesNo />

---

## With Label

export function LabeledYesNo() {
  const [value, setValue] = useState(undefined);
  return <YesNo label="Do you agree to the terms?" onUpdate={setValue} />;
}

<LabeledYesNo />

---

## Custom Labels

export function CustomLabelsYesNo() {
  const [value, setValue] = useState(undefined);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <YesNo label="Accept cookies?" labelA="Accept" labelB="Decline" onUpdate={setValue} />
      <YesNo label="Enable notifications?" labelA="Enable" labelB="Disable" onUpdate={setValue} />
      <YesNo label="Subscribe to newsletter?" labelA="Subscribe" labelB="No thanks" onUpdate={setValue} />
    </div>
  );
}

<CustomLabelsYesNo />

---

## With Default State

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <YesNo label="Pre-selected Yes" defaultState={true} onUpdate={() => {}} />
  <YesNo label="Pre-selected No" defaultState={false} onUpdate={() => {}} />
  <YesNo label="No default (undefined)" onUpdate={() => {}} />
</div>

---

## Three-State Selection

The YesNo component supports three states: true (Yes), false (No), and undefined (neither selected).

export function ThreeStateDemo() {
  const [value, setValue] = useState(undefined);
  const getStateLabel = () => {
    if (value === true) return "Yes selected";
    if (value === false) return "No selected";
    return "Nothing selected";
  };
  return (
    <div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem", maxWidth: "300px" }}>
      <YesNo label="Has previous experience?" onUpdate={setValue} />
      <p style={{ marginTop: "0.75rem", padding: "0.5rem", background: "#f5f5f5", borderRadius: "4px" }}>
        State: {getStateLabel()}
      </p>
      <p style={{ marginTop: "0.5rem", fontSize: "12px", color: "#666" }}>
        Click the same option again to deselect it.
      </p>
    </div>
  );
}

<ThreeStateDemo />

---

## Form Context Example

export function FormExample() {
  const [employed, setEmployed] = useState(undefined);
  const [remote, setRemote] = useState(undefined);
  const [relocation, setRelocation] = useState(undefined);
  return (
    <div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem", maxWidth: "350px" }}>
      <h4 style={{ margin: "0 0 1rem 0" }}>Employment Survey</h4>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        <YesNo label="Are you currently employed?" onUpdate={setEmployed} />
        <YesNo label="Do you work remotely?" onUpdate={setRemote} />
        <YesNo label="Open to relocation?" onUpdate={setRelocation} />
      </div>
    </div>
  );
}

<FormExample />


